/* Placeholder for the play area when GET /today returns no puzzle —
   pre-launch, gap in the publishing pipeline, or the API is down.
   Friendly headline + a large countdown to 00:00 UTC. The state's
   loadError signal isn't shown verbatim; the headline is the
   player-facing surface and the underlying error is left to the
   browser console / DevTools for the dev. */

import { useEffect, useState } from "preact/hooks";
import { formatHms, msUntilNextUtcMidnight } from "../game/countdown";

export function NoPuzzleToday() {
  const [hms, setHms] = useState(() => formatHms(msUntilNextUtcMidnight()));
  useEffect(() => {
    const tick = () => setHms(formatHms(msUntilNextUtcMidnight()));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);
  return (
    <div class="no-puzzle-today" role="alert" aria-live="polite">
      <p class="no-puzzle-today__title">Sorry! No puzzle today.</p>
      <p class="no-puzzle-today__sub">Next puzzle in</p>
      <p class="no-puzzle-today__countdown" aria-label={`Next puzzle in ${hms}`}>
        {hms}
      </p>
    </div>
  );
}
